/// <amd-module name="Artifacts/FeedSettings/hooks/UpstreamSelection" />

import { IUpstreamSource } from "Artifacts/FeedSettings/types";
import { useCallback, useEffect, useState } from "react";
import { IListSelection } from "VSSUI/List";

export interface IUpstreamSelection {
  selectedUpstreams: IUpstreamSource[];
}

// Delete this?
/**
 * Hook for managing the selection of upstreams from a list/table
 * @param selection IListSelection observable object tied to the table component
 * @param upstreams full list of upstreams in the list
 * @returns array of currently selected upstreams
 */
export function useUpstreamSelection(
  selection: IListSelection,
  upstreams?: IUpstreamSource[],
): IUpstreamSelection {
  const [selectedUpstreams, setSelectedUpstreams] = useState<IUpstreamSource[]>([]);

  // Get an array of selected upstreams based on the IListSelection object
  const filterSelectedUpstreams = useCallback((): void => {
    const selectedUpstreams: IUpstreamSource[] = [];

    selection.value.forEach((s) => {
      const selectedUpstreamChunk = upstreams?.slice(s.beginIndex, s.endIndex + 1);
      selectedUpstreamChunk?.forEach((upstream) => selectedUpstreams.push(upstream));
    });

    setSelectedUpstreams(selectedUpstreams);
  }, [selection.value, upstreams]);

  useEffect(() => {
    filterSelectedUpstreams();
    selection.subscribe(filterSelectedUpstreams);
    return () => {
      selection.unsubscribe(filterSelectedUpstreams);
    };
  }, [filterSelectedUpstreams, selection]);

  return {
    selectedUpstreams,
  };
}
